/**
 * @generated SignedSource<<3768f0ae43f38eb911a6e0a2b5486f0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespCondensedListedContent_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarousel_user" | "PdpSharedCondensedSidebarButtons_user" | "PdpSharedPromoCode_user">;
  readonly " $fragmentType": "PdpRespCondensedListedContent_user";
};
export type PdpRespCondensedListedContent_user$key = {
  readonly " $data"?: PdpRespCondensedListedContent_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedListedContent_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespCondensedListedContent_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCondensedSidebarButtons_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e8316df358e10a09fd12c8f0e22785d1";

export default node;
